import { render } from "./AdminYellowNewCategory.vue?vue&type=template&id=67cc1ec2"
import script from "./AdminYellowNewCategory.vue?vue&type=script&lang=js"
export * from "./AdminYellowNewCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__